<script lang="ts">
  import Spinner from '$shared/atoms/Spinner/Spinner.svelte';
  import ToggleLabelButton from '$shared/atoms/ToggleLabelButton/ToggleLabelButton.svelte';
  import { ProfileMergeAction } from '$provider/constants/ProfileMergeAction';

  interface Props {
    checked?: boolean;
    mergeAction?: string;
    loading?: boolean;
    onchange?: (e: Event) => void;
  }

  let { checked = false, mergeAction = '', loading = false, onchange }: Props = $props();
</script>

<div class="comp-merge-add-record-banner">
  <div class="text">Do you want to add this new record?</div>
  <div class="toggle-action">
    {#if loading}
      <Spinner />
    {:else if mergeAction !== ProfileMergeAction.Merge}
      <ToggleLabelButton actionLabel={mergeAction} {checked} name="add-toggle" {onchange} />
    {/if}
  </div>
</div>

<style>
  .comp-merge-add-record-banner {
    background-color: #ffffff;
    border: 1px solid #0d54f5;
    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 16px;
    margin-bottom: 32px;
  }
  .comp-merge-add-record-banner .text {
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
    color: var(--blue);
  }

  .comp-merge-add-record-banner .toggle-action {
    font-weight: normal;
    font-size: 12px;
    line-height: 23px;
    color: var(--grey-medium);
    margin-left: 16px;
  }
</style>
